/**
 * Switcher metadata for the Omni Command shell (EDNA-2005). Extracted from
 * federation-entry.ts so the shell can build its icon rail from `meta` without
 * pulling the whole Projects bundle into its initial chunk — federation-entry
 * re-exports this, so the entry contract is unchanged.
 */
export const meta = {
  id: 'projects',
  label: 'Projects',
  icon: 'KanbanSquare',
  basePath: '/projects',
  /**
   * Kinds this remote can resolve a context card for. The shell consults
   * this when dispatching a `peek-*` event so it never calls a provider
   * for a `kind` it doesn't handle.
   */
  contextCardSupport: ['customer', 'task', 'project']
} as const
